import { ICustomBinding } from "#/DefaultViewExtensionInterfaces";

export default class TechnicalNameBinding implements ICustomBinding {

    public initBinding() {
        ko.bindingHandlers.technicalName = {
            init: (element: HTMLElement, valueAccessor: () => string) => {
                let name = ko.unwrap(valueAccessor());
                if (name == null || name == '') {
                    return;
                }

                $(element).attr('data-technical-name', name);
            }
        };
    }
}